import { LayerSettings, useSelectedLayers } from '@lidojs/design-editor';
import React from 'react';

const AppLayerSettings = () => {
  const { selectedLayerIds } = useSelectedLayers();
  return (
    <div
      css={(theme) => ({
        background: theme.colors.background,
        borderBottom: `1px solid ${theme.colors.stroke}`,
        height: 50,
        overflowX: 'auto',
        flexShrink: 0,
        '@media (max-width: 1024px)': {
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          background: theme.colors.background,
          display: selectedLayerIds.length > 0 ? 'flex' : 'none',
          justifyContent: 'center',
          zIndex: 20,
          height: 72,
        },
      })}
    >
      <LayerSettings />
    </div>
  );
};

export default AppLayerSettings;
